import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ViewTest from './ViewTest';
import { useApiClient } from '../../clients/apiAuth';
import { connect } from 'react-redux';
import { store } from '../../store';
import { setContrato, setSelContrato } from '../../actions';
import { CustomToast, OkToast } from '../../components/specific/Toast';
import toast from 'react-hot-toast';

const Test = (props) => {
  const { get, post, put } = useApiClient();
  const [modalAgregarContrato, setModalAgregarContrato] = useState(false);
  const [clienteOptions, setClienteOptions] = useState([]);
  const [loadingTables, setLoadingTables] = useState(false);

  const [terceroFilter, setTerceroFilter] = useState('');

  const getContratos = async () => {
    try {
      if (terceroFilter === '') return;

      const result = await get(`/contrato${'?TERCERO_ID=' + terceroFilter}`);

      store.dispatch(setContrato(result));
    } catch (error) {}
  };

  const createContrato = async (form) => {
    try {
      const result = await post(
        '/contrato',
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) !== '2') {
        //TODO MENOS LAS RESPUESTAS BUENAS.
        CustomToast({ result });
      } else {
        setModalAgregarContrato(false);
        OkToast({ result, message: 'Contrato Agregado!' });
        getContratos();
      }
    } catch (error) {}
  };

  const updateContrato = async (form) => {
    try {
      const result = await put(
        `/contrato/${props.contrato.selContrato.CONTRATO_ID}`,
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) !== '2') {
        //TODO MENOS LAS RESPUESTAS BUENAS.
        CustomToast({ result });
      } else {
        setModalAgregarContrato(false);
        OkToast({ result, message: 'Contrato actualizado!' });
        getContratos();
      }
    } catch (error) {}
  };

  const validate = (values) => {
    const errors = {};
    const requiredFields = ['CONTRATO_NUMERO', 'CONTRATO_FECHA_INICIO', 'CONTRATO_FECHA_FINAL'];
    requiredFields.forEach((field) => {
      if (!values[field]) {
        errors[field] = 'Requerido';
      }
    });
    return errors;
  };

  const getClientes = async () => {
    setLoadingTables(true);
    try {
      const response = await get(`/tercero?ROL_ID=6&paginate=0`);

      const lst = response.data.map((row) => ({
        label: `${row.TERCERO_NOMBRE_BUSQUEDA}`,
        value: row.TERCERO_ID,
      }));

      setClienteOptions(lst);
      setTerceroFilter(lst[0].value);

      getContratos();
    } catch (error) {}
    setLoadingTables(false);
  };

  const handleEdit = (obj) => {
    console.log('handleEdit obj: ', obj);
    store.dispatch(setSelContrato(obj));
    setModalAgregarContrato(true);
  };

  function handleDelete(rowID) {
    toast((t) => (
      <span>
        <b>Are you sure to delete task?</b>
        <button
          className="ml-2 rounded-full  border px-4 hover:bg-gray-200 "
          onClick={() => {
            toast.dismiss(t.id);
            //deleteContrato(rowID);
          }}>
          Yes
        </button>
        <button
          className="ml-2 rounded-full  border px-4 hover:bg-gray-200 "
          onClick={() => toast.dismiss(t.id)}>
          No
        </button>
      </span>
    ));
  }

  useEffect(() => {
    getClientes();
  }, []);

  useEffect(() => {
    getContratos();
  }, [terceroFilter]);

  return (
    <ViewTest
      modal={{
        modalAgregarContrato,
        setModalAgregarContrato,
      }}
      data={{ clienteOptions, setClienteOptions, terceroFilter, setTerceroFilter }}
      endPoint={{ getClientes, createContrato, validate, updateContrato }}
      actions={{ loadingTables, handleEdit, handleDelete }}
    />
  );
};

const mapStateToProps = function (state) {
  return { contrato: state.contrato };
};

//export default Projects;
export default connect(mapStateToProps)(Test);
